window.Accordion = () => {
	return {
		// Unique slug of the currently open tab. Null means every tab is closed.
		current: null,

		// Tabs call this on init; the first one to arrive opens.
		register(id) {
			if (this.current === null) this.current = id;
		},

		// Called by a tab header. Open the clicked tab, or close it if it was
		// already open — so only one tab is ever open at a time.
		toggle(id) {
			this.current = this.current === id ? null : id;
		},

		// Whether the given tab is the open one.
		isOpen(id) {
			return this.current === id;
		},
	};
};
